import { api } from "../../api/endpoints";
import {
    GET_NOTES_SUCCESS,
    SAVE_NOTE,
    DELETE_NOTE,
    GET_SCHEDULERS_SUCCESS,
    SHOW_ERROR,
    CREATE_SCHEDULER,
    EDIT_SCHEDULER,
    REMOVE_SCHEDULER,
    ADD_EVENT,
    DELETE_EVENTS_PAIR,
    EDIT_EVENT_PAIR,
    MOVE_PAIR,
    COPY_PAIR,
} from "../constant";


// export const get = (id) => {
//     return async (dispatch) => {
//         const response = await api.get(`/user/${id}/note`);
//         if (response.status === 200) {
//             dispatch({
//                 type: GET_NOTES_SUCCESS,
//                 payload: response.data,
//             });
//         }
//     };
// };

export const resetError = () => {
    return async (dispatch) => {
        dispatch({
            type: SHOW_ERROR,
            payload: ''
        })
    }
}

export const getSchedulers = () => {
    return async (dispatch) => {
        try {
            const schedulers = await api.get('/scheduler/getSchedulers')
            dispatch({
                type: GET_SCHEDULERS_SUCCESS,
                payload: schedulers.data.schedulers
            })
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const createScheduler = (data)  => {
    return async (dispatch) => {
        try {
            const scheduler = await api.post('/scheduler/createScheduler', data)
            dispatch({
                type: CREATE_SCHEDULER,
                payload: scheduler.data.scheduler
            })
            return scheduler
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const editScheduler = (data)  => {
    return async (dispatch) => {
        try {
            const scheduler = await api.patch('/scheduler/editScheduler', data)
            dispatch({
                type: EDIT_SCHEDULER,
                payload: scheduler.data.scheduler
            })
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const removeScheduler = (id) => {
    return async (dispatch) => {
        try {
            await api.delete(`/scheduler/deleteScheduler/${id}`)
            dispatch({
                type: REMOVE_SCHEDULER,
                payload: id
            })
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const addEvent = (data) => {
    return async (dispatch) => {
        try {
            const scheduler = await api.post('/scheduler/addEvent', data)
            dispatch({
                type: ADD_EVENT,
                payload: scheduler.data
            })
            return scheduler
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const deleteEventPair = (id, schedulerId) => {
    return async (dispatch) => {
        try {
            const res = await api.delete(`/scheduler/deleteEventPair/${id}`)
            dispatch({
                type: DELETE_EVENTS_PAIR,
                payload: {
                    pairId: id,
                    schedulerId: schedulerId
                }
            })
            return res.data.screensAttachedToScheduler
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const editEventPair = (data) => {
    return async (dispatch) => {
        try {
            const editResponse = await api.patch('/scheduler/editEventPair', data)
            dispatch({
                type: EDIT_EVENT_PAIR,
                payload: {
                    startEvent: editResponse.data.eventStart,
                    endEvent: editResponse.data.eventStop
                }
            })
            return editResponse
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const movePair = (pairId, scheduler, oldScheduler) => {
    return async (dispatch) => {
        try {
            await api.patch('/scheduler/movePair', {
                pairId: pairId,
                scheduler: scheduler
            })
            dispatch({
                type: MOVE_PAIR,
                payload: {
                    pairId,
                    scheduler,
                    oldScheduler
                }
            })
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

export const copyPair = (pairId, scheduler) => {
    return async (dispatch) => {
        try {
            const resp = await api.patch('/scheduler/copyPair', {
                pairId: pairId,
                scheduler: scheduler
            })
            dispatch({
                type: COPY_PAIR,
                payload: {
                    pairs: [resp.data.eventStart, resp.data.eventStop],
                    scheduler
                }
            })
        } catch (err) {
            dispatch({
                type: SHOW_ERROR,
                payload: err?.response?.data?.message
            })
        }
    }
}

